import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { installApiClient } from './lib/apiClient.js'
installApiClient()
window.TIPO_CAMBIO_USD = 17;

// Silenciar errores benignos disparados por extensiones de Chrome (gestores de contraseñas, VoIP, etc.)
window.addEventListener('unhandledrejection', (event) => {
  const msg = String(event?.reason?.message || event?.reason || '');
  if (msg.includes('Could not establish connection. Receiving end does not exist')) {
    event.preventDefault();
  }
});

import { triggerChunkReload } from './lib/chunkErrorUtils.js'

// Manejo automático de chunks desactualizados tras un nuevo despliegue en producción
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  triggerChunkReload();
});

import App from './App.jsx'

import ErrorBoundary from './ErrorBoundary.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
